/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Serializer for registration endpoint.
 * @export
 * @interface APIRegisterRequest
 */
export interface APIRegisterRequest {
    /**
     * 
     * @type {string}
     * @memberof APIRegisterRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof APIRegisterRequest
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof APIRegisterRequest
     */
    password2: string;
    /**
     * 
     * @type {string}
     * @memberof APIRegisterRequest
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof APIRegisterRequest
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof APIRegisterRequest
     */
    organization: string;
}

/**
 * Check if a given object implements the APIRegisterRequest interface.
 */
export function instanceOfAPIRegisterRequest(value: object): value is APIRegisterRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    if (!('password2' in value) || value['password2'] === undefined) return false;
    if (!('organization' in value) || value['organization'] === undefined) return false;
    return true;
}

export function APIRegisterRequestFromJSON(json: any): APIRegisterRequest {
    return APIRegisterRequestFromJSONTyped(json, false);
}

export function APIRegisterRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIRegisterRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'password': json['password'],
        'password2': json['password2'],
        'firstName': json['first_name'] == null ? undefined : json['first_name'],
        'lastName': json['last_name'] == null ? undefined : json['last_name'],
        'organization': json['organization'],
    };
}

export function APIRegisterRequestToJSON(value?: APIRegisterRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
        'password': value['password'],
        'password2': value['password2'],
        'first_name': value['firstName'],
        'last_name': value['lastName'],
        'organization': value['organization'],
    };
}

